<template>
  <i class="material-icons" :style="style">{{icon}}</i>
</template>

<script>
export default {
  name: 'UiIcon',
  props: {
    icon: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  computed: {
    style() {
      let style = {}
      let size = this.size + 'px'
      style.display = 'inline-block'
      style.fontSize = size
      style.width = size
      style.color = this.color
      return style
    }
  },
  mounted() {
    console.log()
  }
}
</script>



// WEBPACK FOOTER //
// src/core/components/Icon.vue